import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2fbe3628&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2fbe3628&prod&scoped=true&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=2fbe3628&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbe3628",
  null
  
)

export default component.exports